<div class="review" data-test="quizReview">

    <!-- summary view -->
    <ng-container *ngIf="showSummaryEnabled">
    
        <!-- header -->
        <div class="text-center" data-test="quizSummary">
        
            <!-- score -->
            <app-progress-circle [progress]="quizScore?.score" size="medium">    
            </app-progress-circle>

            <div class="mt-8 text-18 text-semibold">
                Quiz Complete
            </div>
            
            <div class="mv-4 text-14 text-medium">
                You answered {{ quizScore?.correctTotal }} of {{ quizScore?.scorableTotal }} questions correctly.
            </div>

        </div>

        <!-- user responses -->
        <div *ngIf="showExplanationEnabled && showExplanation" class="review__summary mb-4" data-test="quizExplanation">

            <!-- questions + answers -->
            <div class="mv-6" *ngFor="let question of questions; let i = index;">
                <app-view-quiz-answer [question]="question" [questionNumber]="i + 1" [answer]="quizScore?.questionAnswers[question.id]" [summary]="true">
                </app-view-quiz-answer>
            </div>

        </div>

    </ng-container>

    <!-- actions -->
    <div class="review__actions">

        <button 
            *ngIf="showSummaryEnabled && showExplanationEnabled"
            class="w-100"
            app-button
            buttonType="outline"
            buttonTheme="light"
            data-test="quizToggleSummaryButton"
            (click)="handleToggleSummaryClick()">
            {{ showExplanation ? 'Hide Summary' : 'Show Summary' }}
        </button>

        <button 
            *ngIf="!(quizLocked$ | async)"
            class="mt-8 w-100"
            app-button
            buttonType="info"
            buttonTheme="light"
            data-test="quizTakeAgainButton"
            (click)="handleRestartClick()">
            Take Again
        </button>

        <button 
            *ngIf="!(quizLocked$ | async)"
            class="mt-3 w-100"
            app-button
            buttonType="info"
            buttonTheme="light"
            data-test="quizExitButton"
            (click)="handleExitClick()">
            Back to View
        </button>

    </div>

</div>